import React, { useMemo } from "react"
import { TextField, Button, Typography } from "@mui/material"
import ReactQuill, { Quill } from "react-quill"
import "react-quill/dist/quill.snow.css"
import { slugify } from "../../Utils/slugify"

// -----------------------------
// CUSTOM QUILL FONT SIZES
// -----------------------------
const Size = Quill.import("attributors/style/size");

Size.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "28px",
  "32px",
  "36px",
  "40px",
  "48px",
];

Quill.register(Size, true);

const modulesConfig = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],

    [
      {
        size: [
          "12px",
          "14px",
          "16px",
          "18px",
          "20px",
          "24px",
          "28px",
          "32px",
          "36px",
          "40px",
          "48px",
        ],
      },
    ],

    [{ color: [] }, { background: [] }],

    ["bold", "italic", "underline", "strike"],

    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],

    [{ list: "ordered" }, { list: "bullet" }],

    [{ indent: "-1" }, { indent: "+1" }],

    ["blockquote"],

    ["link", "image", "video"],

    ["clean"],
  ],
  
};
const formats = [
  "header",
  "size",
  "color",
  "background",
  "bold",
  "italic",
  "underline",
  "strike",
  "align",
  "list",
  "bullet",
  "indent",
  "blockquote",
  "link",
  "image",
  "video",
];

function BlogForm({blog,setBlog,onSubmit,editStatus}){
  const modules = useMemo(() => modulesConfig, []);

 
const handleChange = (e) => {
  const { name, value } = e.target;

  setBlog((prev) => {
    const updatedBlog = {
      ...prev,
      [name]: value,
    };

    // auto-generate slug from title
    if (name === "title") {
      updatedBlog.slug = slugify(value);
    }

    return updatedBlog;
  });
};

const handleImage=(e)=>{

const file = e.target.files[0]
const reader = new FileReader()

reader.onload=()=>{

setBlog({
...blog,
image:reader.result
})

}

reader.readAsDataURL(file)


}
console.log(blog)

return (
  <>
 <style>
{`
  .ql-toolbar {
    border-radius: 14px 14px 0 0 !important;
    border: 1px solid #dbe3ec !important;
    background: #f8fbff;
    padding: 12px !important;
  }

  .ql-container {
    min-height: 500px;
    border-radius: 0 0 14px 14px !important;
    border: 1px solid #dbe3ec !important;
    background: white;
    font-family: Arial, Helvetica, sans-serif;
  }

  .ql-editor {
    min-height: 500px;
    padding: 28px 32px !important;

    font-family: Arial, Helvetica, sans-serif;
    font-size: 17px;
    line-height: 1.65;
    color: #334155;
  }

  .ql-editor p {
    margin: 0 0 12px 0;
  }

  .ql-editor h1 {
    font-size: 36px;
    line-height: 1.2;
    margin: 30px 0 16px;
    color: #061d34;
    font-weight: 800;
  }

  .ql-editor h2 {
    font-size: 30px;
    line-height: 1.25;
    margin: 26px 0 14px;
    color: #061d34;
    font-weight: 800;
  }

  .ql-editor h3 {
    font-size: 24px;
    line-height: 1.3;
    margin: 22px 0 12px;
    color: #061d34;
    font-weight: 700;
  }

  .ql-editor ul,
  .ql-editor ol {
    margin: 12px 0;
    padding-left: 28px;
  }

  .ql-editor li {
    margin-bottom: 6px;
  }

  .ql-editor blockquote {
    border-left: 4px solid #0078c9;
    margin: 20px 0;
    padding: 12px 20px;
    background: #f8fbff;
    color: #475569;
  }

  .ql-editor img {
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    margin: 20px auto;
    display: block;
  }

  .ql-editor a {
    color: #0078c9;
    text-decoration: underline;
  }


  /* -------------------------------- */
  /* FONT SIZE DROPDOWN LABELS        */
  /* -------------------------------- */

  .ql-snow .ql-picker.ql-size {
    width: 85px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: attr(data-value);
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before {
    content: "Size";
  }
`}
</style>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      padding: "30px 20px",
      background:
        "linear-gradient(to bottom right, #eef5fb, #f8f9fc)",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "1100px",
        background: "#fff",
        borderRadius: "22px",
        padding: "35px",
        boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
      }}
    >
      {/* TITLE */}
      <Typography
        sx={{
          fontSize: "32px",
          fontWeight: 700,
          color: "#1e293b",
          mb: 1,
        }}
      >
        {editStatus ? "Edit Blog" : "Create New Blog"}
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          color: "#000",
          mb: 4,
        }}
      >
        Create and manage your blog content with rich text editor
      </Typography>

      {/* FORM GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "24px",
        }}
      >
        {/* TITLE */}
        <TextField
          label="Blog Title"
          name="title"
          fullWidth
          value={blog.title || ""}
          onChange={handleChange}
          variant="outlined"
          sx={{
            // Label font size
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
            },
            "& .MuiOutlinedInput-root.Mui-focused fieldset": {
              borderColor: "#0078c9",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#0078c9",
            },
            "& .MuiInputBase-input": {
      fontSize: "16px",
    },
    "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
          }}
        />

        {/* AUTHOR */}
        <TextField
          label="Author"
          name="author"
          fullWidth
          value={blog.author || ""}
          onChange={handleChange}
          variant="outlined"
          sx={{
            // Label font size
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
            },
            "& .MuiOutlinedInput-root.Mui-focused fieldset": {
              borderColor: "#0078c9",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#0078c9",
            },
           "& .MuiInputBase-input": {
      fontSize: "16px",
    },
     "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
   color:"#000"
},
          }}
        />
      </div>

      {/* DESCRIPTION */}
      <TextField
        label="Short Description"
        name="description"
        fullWidth
        multiline
        rows={4}
        margin="normal"
        value={blog.description  || ""}
        onChange={handleChange}
        sx={{
          mt: 3,
          // Label font size
    "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
          },
          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "#0078c9",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#0078c9",
          },
          "& .MuiInputBase-input": {
      fontSize: "16px",
       lineHeight: "1.6", // <-- ADD HERE
    },
     "& .MuiInputLabel-root.MuiInputLabel-shrink": {
  fontSize: "16px",
  transform: "translate(14px, -9px) scale(1)",
  backgroundColor: "#fff",
  padding: "0 5px",
  color:"#000"
},
        }}
      />

      {/* IMAGE UPLOAD */}
      <div
        style={{
          marginTop: "30px",
          padding: "24px",
          border: "2px dashed #cbd5e1",
          borderRadius: "18px",
          background: "#f8fbff",
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
            color: "#1e293b",
            mb: 1,
          }}
        >
          Upload Featured Image
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: "#000",
            mb: 2,
          }}
        >
          Recommended size: 1200 x 600 px
        </Typography>

        <input
          type="file"
          onChange={handleImage}
        />

        {blog.image && (
          <div
            style={{
              marginTop: "20px",
            }}
          >
            <img
              src={blog.image}
              alt="preview"
              style={{
                width: "220px",
                borderRadius: "14px",
                border: "3px solid white",
                boxShadow:
                  "0 8px 20px rgba(0,0,0,0.12)",
              }}
            />
          </div>
        )}
      </div>

      {/* CONTENT */}
      <div style={{ marginTop: "35px" }}>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: "#1e293b",
            mb: 2,
          }}
        >
          Blog Content
        </Typography>

        <style>
          {`
            .ql-toolbar {
              border-radius: 14px 14px 0 0;
              border: 1px solid #dbe3ec;
              background: #f8fbff;
            }

            .ql-container {
              min-height: 500px;
              border-radius: 0 0 14px 14px;
              border: 1px solid #dbe3ec;
              font-size: 16px;
              background: white;
            }

            .ql-editor {
              min-height: 500px;
            }

            .ql-editor:focus {
              border-color: #0078c9;
            }
          `}
        </style>

       <ReactQuill
  value={blog.content || ""}
  onChange={(value) =>
    setBlog((prev) => ({
      ...prev,
      content: value,
    }))
  }
  modules={modules}
  formats={formats}
  theme="snow"
/>
      </div>

      {/* ACTION BUTTON */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "40px",
        }}
      >
        <Button
          variant="contained"
          onClick={onSubmit}
          sx={{
            height: "52px",
            minWidth: "190px",
            borderRadius: "12px",
            fontWeight: 700,
            fontSize: "15px",
            textTransform: "none",
            background:
              "#0078c9",
            boxShadow:
              "0 10px 25px rgba(0,120,201,0.25)",
            ":hover": {
              background:
                "#0078c9",
            },
          }}
        >
          {editStatus ? "Update Blog" : "Submit for Review"}
        </Button>
      </div>
    </div>
  </div>
  </>

);

}

export default BlogForm